<template>
    <div class="configurator-load-configuration-number" :class="textAlign">
        <div class="loadConfigurationText">
            <a href='#' v-on:click="toggleInput" class="btn btn-secondary loadConfigurationButton"><i class="fas fa-clipboard-check mr-1"></i> {{ $t('personalize.loadConfigurationButtonOpen') }}</a><br/>
        </div>
        <div class="d-none p-3 border" v-bind:class="{ 'd-block': isActive }">
            <p>{{ $t('personalize.loadConfigurationText1') }}</p>
            <p>{{ $t('personalize.loadConfigurationText2') }}</p>
            <input type="number" :placeholder="$t('personalize.loadConfigurationPlaceholder')" class="form-control" v-model="configNumber" />
            <button class="btn btn-primary btn-load-config" v-on:click="loadConfig">{{ $t('personalize.loadConfigurationButton') }} <i class="fal fa-angle-right"></i></button>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'LoadConfigurationNumber',
        props: {
            textAlign: String
        },
        data() {
            return {
                configNumber: '',
                isActive: false
            }
        },
        methods: {
            toggleInput: function(e) {
                e.preventDefault();

                // Check value
                if(this.isActive){
                    this.isActive = false;
                }else{
                    this.isActive = true;
                }
            },
            loadConfig: function(e) {
                e.preventDefault();

                let app = this;
                let parent = app.$parent;
                let configKey = app.configNumber;
                let params = new URLSearchParams();
                params.append('apikey', this.$apikey);
                params.append('apipassword', this.$apipassword);
                params.append('ConfigKey', configKey);
                app.popupError = false;
                parent.$parent.loading = true;
                parent.bikeSelected = 0;
                parent.$parent.bikeSelected = 0;

                app.loadConfigPost(app,parent,params);
            },
            loadConfigPost(app,parent,params) {
                this.$http.post(this.$apiurl + '/api/LoadConfig', params)
                    .then(response => {
                        if(response.data['TransferData']['Message']) {
                            parent.$parent.popupInfoText = response.data['TransferData']['Message'];
                            parent.$parent.popupInfo = true;
                            parent.$parent.loading = false;
                        }

                        if(response.data['TransferData']['doRefreshGroups'])
                        {
                            parent.bikeSelected = 1;
                            parent.$parent.bikeSelected = 1;
                            parent.$parent.bikeName = response.data['TransferData']['ModelName'];
                            parent.$parent.ConfigurationID = response.data['TransferData']['ConfigurationID'];
                            parent.getGroups(response.data['TransferData']['ConfigurationID']);

                            this.$router.push({ path: 'your-bike' });
                        }
                    })
                    .catch(error => {
                        app.loadConfigPost(app,parent,params);
                    })
            }
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .configurator-load-configuration-number {
        font-size: 13px;
        font-weight: 500;
        line-height: 1.85;
        letter-spacing: 0.21px;
    }
    .configurator-load-configuration-number p {
        font-size: 13px;
        font-weight: 500;
        line-height: 1.85;
        letter-spacing: 0.21px;
    }

    .configurator-load-configuration-number .btn-load-config {
        clip-path: polygon(10% 0, 100% 0%, 90% 100%, 0% 100%);
    }
    .configurator-load-configuration-number >>> .bmd-form-group {
        padding-top: 0;
    }
    .configurator-load-configuration-number >>> .form-control {
        min-width: 200px;
        width: auto;
        background-image: none;
        border: 1px solid #afb0af;
        padding: 8px 13px;
        height: 40px;
        display: inline-block;
    }
    .configurator-load-configuration-number .btn-load-config {
        position: relative;
        left: -5%;
        top: -1px;
        width: 34%;
    }

    .configurator-load-configuration-number .loadConfigurationText a {
        text-transform: uppercase;
    }

    @media (min-width: 768px) {
        .configurator-load-configuration-number >>> .form-control {
            min-width: 100px;
            width: 100px;

        }
        .configurator-load-configuration-number .btn-load-config {
            width: 100px;
        }
    }
    @media (min-width: 992px) {
        .configurator-load-configuration-number >>> .form-control {
            min-width: 150px;
            width: 150px;
        }
        .configurator-load-configuration-number .btn-load-config {
            width: 130px;
        }
    }
</style>